import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const ButtonWrap = styled.button`
  position: relative;
  padding: 16px 8px;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
  }

  &.active {
    background-color: ${theme.wild.color.nova.base.solid[20]};
  }

  &.inactive {
    background-color: ${theme.wild.color.nova.transparency.white[10]};

    h4 {
      color: ${theme.wild.color.nova.base.white};
    }
  }

  &.active {
    .progress {
      position: absolute;
      background-color: ${theme.wild.color.nova.transparency.black[10]};
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      animation: progress 5s linear;
    }

    @keyframes progress {
      from {
        width: 0;
      }
      to {
        width: 100%;
      }
    }
  }

  h4 {
    position: relative;
    z-index: 1;
  }
`
